import type { KyInstance } from 'ky';

import { ensureError, formatString } from '@enterprise/core';
import type { OperationResultWithData } from '@enterprise/types';

import { Uri } from '#constants/uri';

import type { RoleDetail } from './types/role-detail.type';

/**
 * Fetches a single role, including the permissions granted to it.
 *
 * @param instance - Ky HTTP instance from the application store.
 * @param uid - Unique identifier of the role.
 * @returns OperationResultWithData wrapping `RoleDetail`.
 */
export const getRole = async (instance: KyInstance, uid: string) => {
  try {
    return await instance.get<OperationResultWithData<RoleDetail>>(formatString(Uri.roles.byUid, uid)).json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
